module.exports = __webpack_public_path__ + "static/media/lock_icon.00e7f403.jpg";